// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UserRequestModel from '../../model/user-request-model';
import UserRequestDTO from '../dto/user-request-dto';
import dtoSchema from '../schemas/user-request-schema';

export default abstract class UserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UserRequestDTO>) {
    super();
    if (data) {
      this.email = data.email ?? undefined;
      this.password = data.password ?? undefined;
      this.repeatPassword = data.repeatPassword ?? undefined;
    }
  }
  /**
  */
  email?: string;
  /**
  */
  password?: string;
  /**
  */
  repeatPassword?: string;

  static toModel(dto: DeepPartial<UserRequestDTO>): UserRequestModel;
  static toModel(dto: DeepPartial<UserRequestDTO> | undefined | null): UserRequestModel | undefined;
  static toModel(dto: DeepPartial<UserRequestDTO> | undefined | null): UserRequestModel | undefined {
    return dto ? new UserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UserRequestModel> | UserRequestModel): UserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      email: unwrapped.email,
      password: unwrapped.password,
      repeatPassword: unwrapped.repeatPassword,
    } as UserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UserRequestModel, can not map to UserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
